export const HERO_IMG =
  "https://images.unsplash.com/photo-1593427995298-cad6731716d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBuaWdodHxlbnwwfHx8fDE3ODI5MzI0MDd8MA&ixlib=rb-4.1.0&q=85";
export const VAULT_IMG =
  "https://images.unsplash.com/photo-1777652062282-9b2985cd28d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxnb2xkJTIwdmF1bHQlMjBkb29yJTIwY2xvc2UlMjB1cHxlbnwwfHx8fDE3ODI5MzI0MDZ8MA&ixlib=rb-4.1.0&q=85";
export const PORTRAIT_IMG =
  "https://images.unsplash.com/photo-1663729312345-9fd2a8ff256c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxidXNpbmVzc21hbiUyMHN1aXQlMjBwcmVtaXVtfGVufDB8fHx8MTc4MjkzMjQwNnww&ixlib=rb-4.1.0&q=85";

export const PHONE = "+1 (202) 280-0579";
export const PHONE_HREF = "tel:+12022800579";
export const EMAIL = "SUPPORT@LENDINGLOANSUSA.COM";
export const EMAIL_HREF = "mailto:support@lendingloansusa.com";
